import { render, staticRenderFns } from "./UpdateTelegramAccount.vue?vue&type=template&id=47d98750"
import script from "./UpdateTelegramAccount.vue?vue&type=script&lang=js"
export * from "./UpdateTelegramAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports